/**
 * Domain split helpers.
 *
 * The marketing site (landing + waitlist) is served from the apex
 * `bocapital.co.uk` (+ `www`); the application (login, dashboard, investor
 * portal) is served from `app.bocapital.co.uk`. Both are the same SPA bundle in
 * the same container — the host decides which route tree renders.
 *
 * localhost / 127.0.0.1 / Capacitor are intentionally NOT marketing hosts so
 * dev + the mobile shell keep the full app tree (login included).
 */

export const MARKETING_HOSTS = ['bocapital.co.uk', 'www.bocapital.co.uk'];
export const APP_HOST = 'app.bocapital.co.uk';

const MARKETING_ORIGIN = 'https://bocapital.co.uk';
const APP_ORIGIN = `https://${APP_HOST}`;

/** True only on the public apex/www marketing host (never on localhost/app/Capacitor). */
export function isMarketingHost(): boolean {
  if (typeof window === 'undefined') return false;
  return MARKETING_HOSTS.includes(window.location.hostname);
}

/** Absolute URL on the application host, e.g. appUrl('/login'). */
export function appUrl(path = '/'): string {
  return `${APP_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}

/** Absolute URL on the public marketing host, e.g. marketingUrl('/#waitlist'). */
export function marketingUrl(path = '/'): string {
  return `${MARKETING_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
